<template>
  <div>
    <el-form
      ref="KeyFrom"
      :model="keyMod"
      label-position="top"
      label-width="130px"
      size="mini"
      :rules="rules"
    >
      <el-form-item label="关键字" prop="keyword">
        <el-input v-model="keyMod.keyword"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <a-switch
          v-model:checked="keyMod.state"
          checked-children="启用"
          un-checked-children="禁用"
        />
      </el-form-item>

      <el-form-item label="">
        <el-button type="primary" @click="EditTypeComHandle('KeyFrom')"
          >确定</el-button
        >
        <el-button @click="CancleEdit">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { keywordEdit } from "@/api/keyword";
export default {
  props: {
    keyMod: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      rules: {
        keyword: [
          { required: true, message: "请输入关键字", trigger: "change" },
          { required: true, message: "请输入关键字", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    EditTypeComHandle(formName) {
      this.$refs[formName].validate((valid) => {
        keywordEdit(
          this.keyMod.id,
          this.keyMod.keyword,
          this.keyMod.state
        ).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            if (this.keyMod.id == "") {
              this.$emit("EditComHandle", res.data);
            } else {
              this.$emit("EditComHandle", "");
            }
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    CancleEdit() {
      this.$emit("EditComHandle");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>